import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Box } from "@mui/material";

/**
 * Shared layout for list/CRUD pages.
 * Wraps toolbar, optional title bar, and main content (typically a grid).
 */
const ListPageLayout = ({
  title,
  subtitle,
  toolbarLeft,
  toolbarRight,
  headerAction,
  stats,
  tabs,
  children,
}) => {
  const [titlePortalTarget, setTitlePortalTarget] = useState(null);
  const [actionsPortalTarget, setActionsPortalTarget] = useState(null);

  useEffect(() => {
    setTitlePortalTarget(document.getElementById("header-title-portal"));
    setActionsPortalTarget(document.getElementById("header-actions-portal"));
  }, []);

  const titleContent = title && (
    <Box sx={{ ml: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <h1 style={{ fontSize: '1.25rem', margin: 0, fontWeight: 700, color: 'var(--brand-navy)', lineHeight: 1.2 }}>{title}</h1>
      {subtitle && <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--brand-muted)', lineHeight: 1.2, marginTop: '2px' }}>{subtitle}</p>}
    </Box>
  );

  const actionsContent = headerAction && (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mr: 2 }}>
      {headerAction}
    </Box>
  );

  return (
    <Box className="list-page">
      {titlePortalTarget && titleContent && ReactDOM.createPortal(titleContent, titlePortalTarget)}
      {actionsPortalTarget && actionsContent && ReactDOM.createPortal(actionsContent, actionsPortalTarget)}

      {(toolbarLeft || toolbarRight) && (
        <Box className="page-toolbar">
          <Box className="page-toolbar-left">{toolbarLeft}</Box>
          <Box className="page-toolbar-right">{toolbarRight}</Box>
        </Box>
      )}

      {stats && <Box className="list-page-stats" sx={{ mb: 3 }}>{stats}</Box>}

      <Box className="list-page-card" sx={{ mt: stats ? 0 : 2 }}>
        {tabs && (
          <Box className="list-page-card-header">
            <Box className="list-page-card-header-inner">
              <Box className="list-page-tabs" sx={{ ml: 0 }}>{tabs}</Box>
            </Box>
          </Box>
        )}
        <Box className="list-page-card-body">{children}</Box>
      </Box>
    </Box>
  );
};

export default ListPageLayout;
